import { useState, useEffect } from 'react';
import { Rating } from '../icons/Rating';

export const MAX_NUM = 3;

type Props = {
  value: number;
  onChange: (value:number) => void;
  max?: number;
};

export function Ratings(props: Props) {
  const { value = 0, onChange = () => {}, max = MAX_NUM } = props;
  const [selected, setSelected] = useState(value);

  useEffect(() => {
    onChange(selected); //callback when state changes
  }, [selected]);

  return (
    <div className="flex">
      {[...Array(max)].map((item, number) => {
        return (
          <Rating
            key={number}
            className={`transition-colors cursor-pointer ${
              number + 1 <= selected ? 'fill-primary' : 'fill-disabled hover:fill-secondary '
            } `}
            width={30}
            height={30}
            onClick={() => {
              setSelected(number + 1);
            }}
            //                        onMouseEnter={() => {
            //                            setSelected(number);
            //                        }}
            //                        onMouseLeave={() => {
            //                            setSelected(selected);
            //                        }}
          />
        );
      })}
    </div>
  );
}
